var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiningRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9551 32.9984V23.3984",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04492 32.9984V23.3984",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9082 22.3333V1",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0918 22.3333V1",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23.3984L5 23.3984",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.864 4.20313L8.13672 4.20312",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6367 9.53125C20.6367 8.97897 20.189 8.53125 19.6367 8.53125C19.0844 8.53125 18.6367 8.97897 18.6367 9.53125H20.6367ZM20.6367 22.3312V9.53125H18.6367V22.3312H20.6367Z",
    fill: "var(--brand-color)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3633 9.53125C14.3633 8.97897 13.9156 8.53125 13.3633 8.53125C12.811 8.53125 12.3633 8.97897 12.3633 9.53125H14.3633ZM14.3633 22.3312V9.53125H12.3633V22.3312H14.3633Z",
    fill: "var(--brand-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiningRoom);
export default __webpack_public_path__ + "static/media/dining_room.50a4a585c3eb2a619e8759e474ea4975.svg";
export { ForwardRef as ReactComponent };